<template>
    <el-descriptions v-if="rules.length > 0" title="Regras de Compliance" :column="1" border direction="vertical">
        <el-descriptions-item v-for="dados in rules" :key="dados.code" :label=dados.text>{{dados.status}}</el-descriptions-item>
    </el-descriptions>
</template>
<script>
    export default {
        name: "AnalysisRules",
        props: ['rules'],
    }
</script>  
<style scoped>

</style>
  